import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ExemptionsRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  /**
   * Vehicle registration plate or null.
   * @example
   * 1A13456
   */
  @observable
  licensePlate?: string;

  /**
   * Official record ID or null.
   * @example
   * ABC-23456/2022
   */
  @observable
  officialRecordId?: string;

  /**
   * Country ID.
   * @example
   * 389f9475-192f-476f-9d6e-62934311801b
   */
  @observable
  countryId?: string;

  @observable
  emailAddress?: string;

  @observable
  orderIdent?: number;
}

const customMessage = "oneOfAttributesIsRequired";

const requiredIfCondition = (entity: ExemptionsRequest) => !entity.officialRecordId && !entity.licensePlate;

export const ExemptionRequestValidationRules: EntityValidationRules<ExemptionsRequest> = {
  licensePlate: {
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
    isLicensePlate: {
      required: false,
    },
  },
  officialRecordId: {
    requiredIf: {
      condition: requiredIfCondition,
      customMessage: customMessage,
    },
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
};
